var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:"bom-bulk-update-list",attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"setLoading":_vm.setLoading,"backButtonEnable":false,"persistenceKey":'bill-of-materials-bulk-update-list'}})
}
var staticRenderFns = []

export { render, staticRenderFns }